









import Vue from "vue";
import { Component } from "vue-property-decorator";
import { startQaplaSession } from "@/utils/ssoQapla";

@Component
export default class QaplaButton extends Vue {
  async onStartQaplaSession() {
    if (this.$store.getters.features.qapla.qaplaEnabled) {
      try {
        const resp = await startQaplaSession();
        if (resp) {
          if (resp.result && resp.result == "KO") {
            window.console.error(resp.error);
            this.$alerts.danger(
              `this.$t("qapla_error_connection") + ': ' + ${resp.error}`
            );
          } else {
            window.open(
              resp.Location
                ? resp.Location
                : this.$store.getters.BASE_QAPLA_URL,
              "_BLANK"
            );
          }
        } else {
          this.$alerts.danger(this.$t("qapla_error_connection"));
        }
      } catch (err) {
        window.console.error(err);
        this.$alerts.danger(this.$t("qapla_error_connection"));
      }
    }
  }
}
